// // pages/BlogDetailPage.jsx
// import React, { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import { motion } from "framer-motion";

// const BlogDetailPage = () => {
//   const { id } = useParams();
//   const [blog, setBlog] = useState(null);
//   const [relatedPosts, setRelatedPosts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     window.scrollTo(0, 0);

//     // In a real application, you would fetch the blog post by ID from an API
//     // For this example, we'll simulate fetching with sample data

//     setTimeout(() => {
//       const blogPost = {
//         id: 1,
//         title: "Complete Guide to NPSC Exam Pattern and Syllabus 2025",
//         category: "exam-updates",
//         date: "March 15, 2025",
//         author: "Dr. Imtisunep Ao",
//         authorPosition: "NPSC Exam Expert, Former Commissioner",
//         authorImage:
//           "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5HVVqbKEfRB2KnjIkT9XmJfWcENcZObNPuQ&s",
//         image:
//           "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5NsyFdQozOIkPMgpmo5XGyM7MtjEhT7AeSw&s",
//         readTime: "10 min read",
//         tags: ["Exam Pattern", "Syllabus", "NPSC 2025", "Preparation Strategy"],
//         content: [
//           {
//             type: "paragraph",
//             text: "The Nagaland Public Service Commission (NPSC) examination is one of the most prestigious competitive exams in the state. Understanding its pattern and syllabus thoroughly is crucial for any serious aspirant. This comprehensive guide breaks down everything you need to know about the NPSC examination structure, marking scheme, and subject-wise syllabus for 2025.",
//           },
//           {
//             type: "heading",
//             text: "Examination Structure Overview",
//           },
//           {
//             type: "paragraph",
//             text: "The NPSC examination consists of three main stages: Preliminary Examination, Main Examination, and Interview/Personality Test. Each stage is designed to test different aspects of a candidate's knowledge, aptitude, and personality traits essential for civil services.",
//           },
//           {
//             type: "subheading",
//             text: "1. Preliminary Examination",
//           },
//           {
//             type: "paragraph",
//             text: "The Preliminary Examination serves as a screening test to select candidates for the Main Examination. It consists of two papers:",
//           },
//           {
//             type: "list",
//             items: [
//               "Paper I: General Studies (200 marks) - 2 hours duration",
//               "Paper II: CSAT (Civil Services Aptitude Test) (200 marks) - 2 hours duration",
//             ],
//           },
//           {
//             type: "paragraph",
//             text: "Both papers consist of objective-type (multiple choice) questions. The CSAT paper is qualifying in nature, with a minimum requirement of 33% marks. Only the marks obtained in Paper I will be considered for ranking and selection for the Main Examination.",
//           },
//           {
//             type: "subheading",
//             text: "2. Main Examination",
//           },
//           {
//             type: "paragraph",
//             text: "The Main Examination is of descriptive type, testing the candidate's academic expertise and depth of understanding. It consists of the following papers:",
//           },
//           {
//             type: "list",
//             items: [
//               "Paper I: Essay (150 marks)",
//               "Paper II: General Studies-I (250 marks)",
//               "Paper III: General Studies-II (250 marks)",
//               "Paper IV: General Studies-III (250 marks)",
//               "Paper V: General Studies-IV (250 marks)",
//               "Paper VI: Optional Subject Paper-I (250 marks)",
//               "Paper VII: Optional Subject Paper-II (250 marks)",
//             ],
//           },
//           {
//             type: "blockquote",
//             text: "The Main Examination is the most critical phase of the NPSC selection process, as it tests the candidate's in-depth knowledge, analytical abilities, and written communication skills. Thorough preparation of each subject is essential for success.",
//           },
//           {
//             type: "subheading",
//             text: "3. Interview/Personality Test",
//           },
//           {
//             type: "paragraph",
//             text: "The final stage is the Interview or Personality Test, carrying 250 marks. The interview aims to assess the candidate's suitability for a career in civil services based on various parameters including mental caliber, critical thinking, clarity of expression, leadership traits, intellectual curiosity, and social awareness.",
//           },
//           {
//             type: "heading",
//             text: "Detailed Syllabus for NPSC Preliminary Examination",
//           },
//           {
//             type: "paragraph",
//             text: "Let's explore the detailed syllabus for each paper of the Preliminary Examination:",
//           },
//           {
//             type: "subheading",
//             text: "Paper I: General Studies",
//           },
//           {
//             type: "list",
//             items: [
//               "Current Events of National and International Importance",
//               "History of India and Indian National Movement",
//               "Indian and World Geography - Physical, Social, Economic",
//               "Indian Polity and Governance - Constitution, Political System, Panchayati Raj, Public Policy, Rights Issues, etc.",
//               "Economic and Social Development - Sustainable Development, Poverty, Inclusion, Demographics, Social Sector Initiatives, etc.",
//               "General Science",
//               "Environmental Ecology, Biodiversity and Climate Change",
//               "Nagaland-specific topics: History, Geography, Economy, and Current Affairs",
//             ],
//           },
//           {
//             type: "image",
//             src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSsoe_kmIIj4t4LUUtrdeuA8asck_O9FlJrWg&s",
//             alt: "NPSC Prelims Syllabus Overview",
//             caption:
//               "A visual representation of the NPSC Prelims syllabus distribution",
//           },
//           {
//             type: "subheading",
//             text: "Paper II: Civil Services Aptitude Test (CSAT)",
//           },
//           {
//             type: "list",
//             items: [
//               "Comprehension",
//               "Interpersonal Skills including Communication Skills",
//               "Logical Reasoning and Analytical Ability",
//               "Decision-Making and Problem-Solving",
//               "General Mental Ability",
//               "Basic Numeracy (Class X level)",
//               "Data Interpretation (charts, graphs, tables, data sufficiency, etc.)",
//             ],
//           },
//           {
//             type: "heading",
//             text: "Key Topics for NPSC Main Examination",
//           },
//           {
//             type: "paragraph",
//             text: "The Main Examination is more detailed and requires in-depth preparation. Here's a brief overview of what each paper covers:",
//           },
//           {
//             type: "subheading",
//             text: "Paper I: Essay",
//           },
//           {
//             type: "paragraph",
//             text: "Candidates will be required to write essays on multiple topics. The essay topics can be based on current affairs, social issues, ethics, governance, environmental concerns, or abstract philosophical themes. The essay tests the candidate's ability to present ideas coherently, critically analyze issues, and offer solutions with logical reasoning.",
//           },
//           {
//             type: "subheading",
//             text: "Papers II to V: General Studies",
//           },
//           {
//             type: "paragraph",
//             text: "These papers cover a wide range of subjects including Indian Heritage and Culture, History, Geography, Society, Governance, Constitution, Social Justice, International Relations, Technology, Economic Development, Biodiversity, Environment, Security, and Ethics. Each paper focuses on specific domains and tests both breadth and depth of knowledge.",
//           },
//           {
//             type: "subheading",
//             text: "Papers VI & VII: Optional Subject",
//           },
//           {
//             type: "paragraph",
//             text: "Candidates must choose one optional subject from the list provided by NPSC. The optional subject consists of two papers, each carrying 250 marks. The choice of optional subject is crucial and should be based on the candidate's academic background, interest, and scoring potential.",
//           },
//           {
//             type: "heading",
//             text: "Preparation Strategy for NPSC 2025",
//           },
//           {
//             type: "paragraph",
//             text: "Based on the examination pattern and syllabus, here's a strategic approach to prepare for NPSC 2025:",
//           },
//           {
//             type: "list",
//             items: [
//               "Create a comprehensive study plan covering all subjects",
//               "Focus on Nagaland-specific topics as they carry significant weightage",
//               "Regularly practice answer writing for the Main Examination",
//               "Stay updated with current affairs, especially related to Northeast India",
//               "Take mock tests to familiarize yourself with the exam pattern",
//               "Develop a strategy for the optional subject selection based on your strengths",
//               "Allocate time for revision and practice tests in your preparation timeline",
//             ],
//           },
//           {
//             type: "blockquote",
//             text: "Remember, success in the NPSC examination requires consistent effort, strategic planning, and regular assessment of your preparation level. Focus on understanding concepts rather than rote memorization.",
//           },
//           {
//             type: "heading",
//             text: "Recommended Resources",
//           },
//           {
//             type: "paragraph",
//             text: "To help you with your preparation, here are some recommended resources:",
//           },
//           {
//             type: "list",
//             items: [
//               "NPSC Previous Years' Question Papers",
//               "Standard textbooks for each subject",
//               "Nagaland-specific books on history, culture, and governance",
//               "Current affairs magazines and newspapers",
//               "Online test series and practice platforms",
//               "Subject-specific coaching modules and notes",
//             ],
//           },
//           {
//             type: "conclusion",
//             text: "The NPSC examination is challenging but with the right approach and thorough preparation, success is achievable. Understanding the exam pattern and syllabus is the first step towards a focused and effective preparation strategy. Stay committed to your goals, maintain consistency in your studies, and regularly assess your progress through mock tests and self-evaluation.",
//           },
//         ],
//         views: 2456,
//         shares: 389,
//         likes: 278,
//         comments: [
//           {
//             id: 1,
//             author: "Kevichulie Liegise",
//             date: "March 16, 2025",
//             text: "This is extremely helpful! I was looking for a comprehensive breakdown of the syllabus. Could you please elaborate more on the weightage of Nagaland-specific topics in the exam?",
//             replies: [
//               {
//                 id: 101,
//                 author: "Dr. Imtisunep Ao",
//                 date: "March 16, 2025",
//                 text: "Thank you for your question, Kevichulie! Nagaland-specific topics typically constitute about 20-25% of the General Studies papers, with special emphasis on history, tribal governance systems, customary laws, and current developmental initiatives in the state. I'll cover this in more detail in my upcoming article.",
//               },
//             ],
//           },
//           {
//             id: 2,
//             author: "Atsungla Aier",
//             date: "March 17, 2025",
//             text: "Great article! Is there any change in the syllabus compared to the previous year? Also, which optional subjects have shown good results in recent years?",
//             replies: [],
//           },
//         ],
//       };

//       // Sample related posts
//       const relatedPostsData = [
//         {
//           id: 2,
//           title: "How to Prepare for Nagaland History & Culture Section",
//           category: "preparation",
//           date: "March 10, 2025",
//           excerpt:
//             "Learn effective strategies and recommended resources for mastering the Nagaland History and Culture section, which is crucial for the NPSC examination.",
//           image:
//             "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxEMkifN06kPfUi-yoUxjnq_sW9K_kMm6foQ&s",
//           author: "Vikali Zhimomi",
//         },
//         {
//           id: 6,
//           title: "Effective Answer Writing Techniques for NPSC Mains",
//           category: "preparation",
//           date: "February 15, 2025",
//           excerpt:
//             "Master the art of writing clear, concise, and comprehensive answers for the NPSC Mains examination with these proven techniques and examples.",
//           image:
//             "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBPm1YpTZAmz5vyMJ6iPnIEvZHalIR1cS6kQ&s",
//           author: "Dr. Imtisunep Ao",
//         },
//         {
//           id: 8,
//           title: "NPSC Interview Experience: What to Expect and How to Prepare",
//           category: "preparation",
//           date: "February 5, 2025",
//           excerpt:
//             "Insights into the NPSC interview process with tips from successful candidates and guidance on how to prepare for different types of questions.",
//           image:
//             "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwMaosGwwuSIryd5z7ypRbO6dk85bZF7VC1w&s",
//           author: "Keneilelie Kire",
//         },
//       ];

//       setBlog(blogPost);
//       setRelatedPosts(relatedPostsData);
//       setLoading(false);
//     }, 500); // Simulating API delay
//   }, [id]);

//   if (loading) {
//     return (
//       <div className="pt-20 flex justify-center items-center min-h-screen bg-gray-50">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-700 mx-auto"></div>
//           <p className="mt-3 text-gray-600">Loading article...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!blog) {
//     return (
//       <div className="pt-20 flex justify-center items-center min-h-screen bg-gray-50">
//         <div className="text-center max-w-lg mx-auto px-4">
//           <svg
//             className="h-16 w-16 text-gray-400 mx-auto"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//             />
//           </svg>
//           <h2 className="mt-4 text-xl font-bold text-gray-700">
//             Article Not Found
//           </h2>
//           <p className="mt-2 text-gray-500">
//             The article you're looking for doesn't exist or has been removed.
//           </p>
//           <Link
//             to="/blog"
//             className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
//           >
//             Back to Blog
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   // Function to render content sections
//   const renderContent = (section, index) => {
//     if (section.type === "paragraph") {
//       return (
//         <p key={index} className="mb-6 text-gray-700 leading-relaxed">
//           {section.text}
//         </p>
//       );
//     } else if (section.type === "heading") {
//       return (
//         <h2 key={index} className="text-2xl font-bold text-gray-900 mt-8 mb-4">
//           {section.text}
//         </h2>
//       );
//     } else if (section.type === "subheading") {
//       return (
//         <h3
//           key={index}
//           className="text-xl font-semibold text-gray-800 mt-6 mb-3"
//         >
//           {section.text}
//         </h3>
//       );
//     } else if (section.type === "list") {
//       return (
//         <ul key={index} className="list-disc pl-6 mb-6 space-y-2">
//           {section.items.map((item, itemIndex) => (
//             <li key={itemIndex} className="text-gray-700">
//               {item}
//             </li>
//           ))}
//         </ul>
//       );
//     } else if (section.type === "blockquote") {
//       return (
//         <blockquote
//           key={index}
//           className="border-l-4 border-indigo-500 pl-4 italic my-6 text-gray-600"
//         >
//           {section.text}
//         </blockquote>
//       );
//     } else if (section.type === "image") {
//       return (
//         <figure key={index} className="my-8">
//           <img
//             src={section.src}
//             alt={section.alt}
//             className="w-full rounded-lg shadow-md"
//           />
//           {section.caption && (
//             <figcaption className="text-center text-sm text-gray-500 mt-2">
//               {section.caption}
//             </figcaption>
//           )}
//         </figure>
//       );
//     } else if (section.type === "conclusion") {
//       return (
//         <div
//           key={index}
//           className="mt-8 p-4 bg-indigo-50 rounded-lg border border-indigo-100"
//         >
//           <h3 className="text-xl font-semibold text-indigo-800 mb-2">
//             Conclusion
//           </h3>
//           <p className="text-gray-700">{section.text}</p>
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <div className="pt-20 bg-gray-50">
//       {/* Hero Section */}
//       <section className="relative bg-gray-900 text-white">
//         <div className="absolute inset-0">
//           <div className="absolute inset-0 bg-gray-900 opacity-80"></div>
//           <img
//             src={blog.image}
//             alt={blog.title}
//             className="absolute inset-0 w-full h-full object-cover opacity-40"
//           />
//         </div>
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
//           <div className="text-center">
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//               className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800 mb-6"
//             >
//               {blog.category.charAt(0).toUpperCase() +
//                 blog.category.slice(1).replace(/-/g, " ")}
//             </motion.div>

//             <motion.h1
//               className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight mb-6"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               {blog.title}
//             </motion.h1>

//             <motion.div
//               className="flex items-center justify-center space-x-4 text-sm"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <span className="flex items-center">
//                 <svg
//                   className="h-4 w-4 mr-1"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                   />
//                 </svg>
//                 {blog.date}
//               </span>
//               <span className="flex items-center">
//                 <svg
//                   className="h-4 w-4 mr-1"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//                 {blog.readTime}
//               </span>
//               <span className="flex items-center">
//                 <svg
//                   className="h-4 w-4 mr-1"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                   />
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//                   />
//                 </svg>
//                 {blog.views.toLocaleString()} views
//               </span>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Author Info */}
//       <section className="bg-white border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//           <div className="flex items-center">
//             <div className="flex-shrink-0">
//               <div className="h-12 w-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 text-lg font-bold">
//                 {blog.author.charAt(0)}
//               </div>
//             </div>
//             <div className="ml-4">
//               <div className="text-lg font-medium text-gray-900">
//                 {blog.author}
//               </div>
//               <div className="text-sm text-gray-600">{blog.authorPosition}</div>
//             </div>
//             <div className="ml-auto flex space-x-2">
//               <button className="inline-flex items-center px-3 py-1 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 bg-white hover:bg-gray-50">
//                 <svg
//                   className="h-4 w-4 mr-1"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
//                   />
//                 </svg>
//                 Follow
//               </button>
//               <button className="inline-flex items-center px-3 py-1 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 bg-white hover:bg-gray-50">
//                 <svg
//                   className="h-4 w-4 mr-1"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
//                   />
//                 </svg>
//                 Contact
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Content Section with Sidebar - Grid Layout for full width */}
//       <section className="py-12">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
//             {/* Main Content - Takes more width */}
//             <div className="lg:col-span-8 xl:col-span-9">
//               <motion.div
//                 className="bg-white rounded-lg shadow-md overflow-hidden"
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5 }}
//               >
//                 <div className="p-6 md:p-8">
//                   <div className="prose prose-indigo max-w-none">
//                     {blog.content.map((section, index) =>
//                       renderContent(section, index)
//                     )}
//                   </div>

//                   {/* Tags */}
//                   <div className="mt-8 pt-6 border-t border-gray-200">
//                     <h4 className="text-sm font-medium text-gray-500 mb-3">
//                       Tags
//                     </h4>
//                     <div className="flex flex-wrap gap-2">
//                       {blog.tags.map((tag, index) => (
//                         <Link
//                           key={index}
//                           to={`/blog/tag/${tag
//                             .toLowerCase()
//                             .replace(/\s+/g, "-")}`}
//                           className="px-3 py-1 bg-gray-100 hover:bg-gray-200 text-sm text-gray-700 rounded-full"
//                         >
//                           {tag}
//                         </Link>
//                       ))}
//                     </div>
//                   </div>

//                   {/* Social Sharing */}
//                   <div className="mt-8 pt-6 border-t border-gray-200">
//                     <div className="flex items-center justify-between">
//                       <div className="flex space-x-4">
//                         <button className="flex items-center text-gray-600 hover:text-indigo-600">
//                           <svg
//                             className="h-5 w-5 mr-1"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
//                             />
//                           </svg>
//                           <span>{blog.likes} Likes</span>
//                         </button>
//                         <button className="flex items-center text-gray-600 hover:text-indigo-600">
//                           <svg
//                             className="h-5 w-5 mr-1"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
//                             />
//                           </svg>
//                           <span>{blog.comments.length} Comments</span>
//                         </button>
//                       </div>
//                       <div className="flex space-x-2">
//                         <button className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-full">
//                           <svg
//                             className="h-5 w-5"
//                             fill="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
//                           </svg>
//                         </button>
//                         <button className="p-2 text-gray-500 hover:text-blue-800 hover:bg-blue-50 rounded-full">
//                           <svg
//                             className="h-5 w-5"
//                             fill="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
//                           </svg>
//                         </button>
//                         <button className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-full">
//                           <svg
//                             className="h-5 w-5"
//                             fill="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
//                           </svg>
//                         </button>
//                         <button className="p-2 text-gray-500 hover:text-green-600 hover:bg-green-50 rounded-full">
//                           <svg
//                             className="h-5 w-5"
//                             fill="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
//                           </svg>
//                         </button>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Comments Section */}
//                   <div className="mt-8 pt-6 border-t border-gray-200">
//                     <h3 className="text-xl font-bold text-gray-900 mb-6">
//                       Comments ({blog.comments.length})
//                     </h3>

//                     {/* Comment Form */}
//                     <div className="mb-8">
//                       <h4 className="text-lg font-medium text-gray-900 mb-4">
//                         Leave a comment
//                       </h4>
//                       <form className="space-y-4">
//                         <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
//                           <div>
//                             <label
//                               htmlFor="name"
//                               className="block text-sm font-medium text-gray-700"
//                             >
//                               Name
//                             </label>
//                             <input
//                               type="text"
//                               id="name"
//                               className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//                               placeholder="Your name"
//                             />
//                           </div>
//                           <div>
//                             <label
//                               htmlFor="email"
//                               className="block text-sm font-medium text-gray-700"
//                             >
//                               Email
//                             </label>
//                             <input
//                               type="email"
//                               id="email"
//                               className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//                               placeholder="Your email (will not be published)"
//                             />
//                           </div>
//                         </div>
//                         <div>
//                           <label
//                             htmlFor="comment"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             Comment
//                           </label>
//                           <textarea
//                             id="comment"
//                             rows="4"
//                             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//                             placeholder="Share your thoughts..."
//                           ></textarea>
//                         </div>
//                         <div>
//                           <button
//                             type="submit"
//                             className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
//                           >
//                             Post Comment
//                           </button>
//                         </div>
//                       </form>
//                     </div>

//                     {/* Comments List */}
//                     <div className="space-y-6">
//                       {blog.comments.map((comment) => (
//                         <div
//                           key={comment.id}
//                           className="bg-gray-50 p-4 rounded-lg"
//                         >
//                           <div className="flex">
//                             <div className="flex-shrink-0 mr-3">
//                               <div className="h-10 w-10 rounded-full bg-indigo-200 flex items-center justify-center text-indigo-600 font-medium">
//                                 {comment.author.charAt(0)}
//                               </div>
//                             </div>
//                             <div className="flex-1">
//                               <div className="flex items-center justify-between">
//                                 <h5 className="text-sm font-medium text-gray-900">
//                                   {comment.author}
//                                 </h5>
//                                 <span className="text-xs text-gray-500">
//                                   {comment.date}
//                                 </span>
//                               </div>
//                               <div className="mt-2 text-sm text-gray-700">
//                                 <p>{comment.text}</p>
//                               </div>
//                               <div className="mt-2 flex items-center space-x-4">
//                                 <button className="text-xs text-gray-500 hover:text-indigo-600 flex items-center">
//                                   <svg
//                                     className="h-4 w-4 mr-1"
//                                     fill="none"
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                   >
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
//                                     />
//                                   </svg>
//                                   Like
//                                 </button>
//                                 <button className="text-xs text-gray-500 hover:text-indigo-600 flex items-center">
//                                   <svg
//                                     className="h-4 w-4 mr-1"
//                                     fill="none"
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                   >
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
//                                     />
//                                   </svg>
//                                   Reply
//                                 </button>
//                               </div>

//                               {/* Comment Replies */}
//                               {comment.replies &&
//                                 comment.replies.length > 0 && (
//                                   <div className="mt-4 pl-5 border-l-2 border-gray-200 space-y-4">
//                                     {comment.replies.map((reply) => (
//                                       <div
//                                         key={reply.id}
//                                         className="bg-white p-3 rounded"
//                                       >
//                                         <div className="flex">
//                                           <div className="flex-shrink-0 mr-3">
//                                             <div className="h-8 w-8 rounded-full bg-indigo-200 flex items-center justify-center text-indigo-600 font-medium text-xs">
//                                               {reply.author.charAt(0)}
//                                             </div>
//                                           </div>
//                                           <div className="flex-1">
//                                             <div className="flex items-center justify-between">
//                                               <h6 className="text-sm font-medium text-gray-900">
//                                                 {reply.author}
//                                               </h6>
//                                               <span className="text-xs text-gray-500">
//                                                 {reply.date}
//                                               </span>
//                                             </div>
//                                             <div className="mt-1 text-sm text-gray-700">
//                                               <p>{reply.text}</p>
//                                             </div>
//                                           </div>
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </motion.div>
//             </div>

//             {/* Sidebar - Takes less width */}
//             <div className="lg:col-span-4 xl:col-span-3">
//               <div className="space-y-6">
//                 {/* Author Card */}
//                 <div className="bg-white rounded-lg shadow-md p-6">
//                   <h3 className="text-lg font-medium text-gray-900 mb-4">
//                     About the Author
//                   </h3>
//                   <div className="flex flex-col items-center text-center">
//                     <div className="h-24 w-24 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 text-3xl font-bold mb-4">
//                       {blog.author.charAt(0)}
//                     </div>
//                     <h4 className="text-lg font-medium text-gray-900">
//                       {blog.author}
//                     </h4>
//                     <p className="text-sm text-gray-600 mb-4">
//                       {blog.authorPosition}
//                     </p>
//                     <p className="text-sm text-gray-600 mb-4">
//                       Expert in NPSC examination patterns and Nagaland
//                       administrative affairs. Former civil servant with over 15
//                       years of experience.
//                     </p>
//                     <button className="w-full inline-flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
//                       View Full Profile
//                     </button>
//                   </div>
//                 </div>

//                 {/* Related Posts */}
//                 <div className="bg-white rounded-lg shadow-md p-6">
//                   <h3 className="text-lg font-medium text-gray-900 mb-4">
//                     Related Articles
//                   </h3>
//                   <div className="space-y-4">
//                     {relatedPosts.map((post) => (
//                       <Link
//                         key={post.id}
//                         to={`/blog/${post.id}`}
//                         className="block group"
//                       >
//                         <div className="flex">
//                           <div className="flex-shrink-0 h-14 w-14 rounded overflow-hidden">
//                             <img
//                               src={post.image}
//                               alt={post.title}
//                               className="h-full w-full object-cover group-hover:opacity-80 transition-opacity"
//                             />
//                           </div>
//                           <div className="ml-3">
//                             <p className="text-sm font-medium text-gray-900 group-hover:text-indigo-600 transition-colors line-clamp-2">
//                               {post.title}
//                             </p>
//                             <p className="text-xs text-gray-500 mt-1">
//                               {post.date}
//                             </p>
//                           </div>
//                         </div>
//                       </Link>
//                     ))}
//                     <Link
//                       to="/blog"
//                       className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-800 mt-2"
//                     >
//                       View All Articles
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="h-4 w-4 ml-1"
//                         viewBox="0 0 20 20"
//                         fill="currentColor"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                     </Link>
//                   </div>
//                 </div>

//                 {/* Categories */}
//                 <div className="bg-white rounded-lg shadow-md p-6">
//                   <h3 className="text-lg font-medium text-gray-900 mb-4">
//                     Categories
//                   </h3>
//                   <div className="space-y-2">
//                     {[
//                       { id: "exam-updates", name: "Exam Updates", count: 8 },
//                       {
//                         id: "preparation",
//                         name: "Preparation Tips",
//                         count: 15,
//                       },
//                       {
//                         id: "current-affairs",
//                         name: "Current Affairs",
//                         count: 12,
//                       },
//                       {
//                         id: "success-stories",
//                         name: "Success Stories",
//                         count: 6,
//                       },
//                       {
//                         id: "job-notifications",
//                         name: "Job Notifications",
//                         count: 9,
//                       },
//                     ].map((category) => (
//                       <Link
//                         key={category.id}
//                         to={`/blog/category/${category.id}`}
//                         className="flex items-center justify-between py-2 px-3 rounded-md hover:bg-gray-50"
//                       >
//                         <span className="text-sm text-gray-700">
//                           {category.name}
//                         </span>
//                         <span className="text-xs bg-gray-100 px-2 py-1 rounded-full text-gray-600">
//                           {category.count}
//                         </span>
//                       </Link>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Newsletter */}
//                 <div className="bg-gradient-to-r from-indigo-600 to-blue-700 rounded-lg shadow-md p-6 text-white">
//                   <h3 className="text-lg font-medium mb-4">
//                     Subscribe to Newsletter
//                   </h3>
//                   <p className="text-sm text-indigo-100 mb-4">
//                     Get the latest NPSC updates and preparation tips delivered
//                     to your inbox.
//                   </p>
//                   <form className="space-y-3">
//                     <div>
//                       <input
//                         type="email"
//                         placeholder="Your email address"
//                         className="block w-full px-4 py-2 rounded-md border-0 text-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-300 focus:ring-offset-indigo-600"
//                       />
//                     </div>
//                     <button
//                       type="submit"
//                       className="w-full bg-white text-indigo-600 px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors"
//                     >
//                       Subscribe
//                     </button>
//                   </form>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Next/Previous Article Navigation - Full Width */}
//       <section className="bg-gray-100 border-t border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <Link
//               to="/blog/previous-article"
//               className="group block bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
//             >
//               <div className="p-6">
//                 <div className="flex items-center text-sm text-gray-500 mb-1">
//                   <svg
//                     className="h-4 w-4 mr-1"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M15 19l-7-7 7-7"
//                     />
//                   </svg>
//                   Previous Article
//                 </div>
//                 <h3 className="text-lg font-medium text-gray-900 group-hover:text-indigo-600 transition-colors">
//                   Recent Administrative Reforms in Nagaland: What Aspirants
//                   Should Know
//                 </h3>
//               </div>
//             </Link>

//             <Link
//               to="/blog/next-article"
//               className="group block bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
//             >
//               <div className="p-6 text-right">
//                 <div className="flex items-center justify-end text-sm text-gray-500 mb-1">
//                   Next Article
//                   <svg
//                     className="h-4 w-4 ml-1"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M9 5l7 7-7 7"
//                     />
//                   </svg>
//                 </div>
//                 <h3 className="text-lg font-medium text-gray-900 group-hover:text-indigo-600 transition-colors">
//                   How to Prepare for Nagaland History & Culture Section
//                 </h3>
//               </div>
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* More Articles You May Like - Full Width Grid */}
//       <section className="py-12 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <h2 className="text-2xl font-bold text-gray-900 mb-8">
//             More Articles You May Like
//           </h2>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {relatedPosts.map((post) => (
//               <motion.div
//                 key={post.id}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5 }}
//                 className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border border-gray-100"
//               >
//                 <Link to={`/blog/${post.id}`}>
//                   <img
//                     src={post.image}
//                     alt={post.title}
//                     className="w-full h-48 object-cover"
//                   />
//                 </Link>
//                 <div className="p-5">
//                   <Link
//                     to={`/blog/${post.id}`}
//                     className="block mt-2 text-xl font-semibold text-gray-900 hover:text-indigo-600 transition-colors duration-200 mb-2"
//                   >
//                     {post.title}
//                   </Link>
//                   <p className="text-gray-600 line-clamp-3 mb-4">
//                     {post.excerpt}
//                   </p>

//                   <div className="flex items-center justify-between">
//                     <div className="flex items-center">
//                       <div className="flex-shrink-0">
//                         <div className="h-8 w-8 rounded-full bg-indigo-200 flex items-center justify-center text-indigo-600 font-medium">
//                           {post.author.charAt(0)}
//                         </div>
//                       </div>
//                       <div className="ml-2">
//                         <p className="text-sm font-medium text-gray-900">
//                           {post.author}
//                         </p>
//                         <p className="text-xs text-gray-500">{post.date}</p>
//                       </div>
//                     </div>

//                     <Link
//                       to={`/blog/${post.id}`}
//                       className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-800"
//                     >
//                       Read more
//                     </Link>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Call to Action */}
//       <section className="py-16 bg-gradient-to-r from-indigo-900 to-blue-800 text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="max-w-3xl mx-auto text-center">
//             <motion.h2
//               className="text-3xl font-extrabold mb-6"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               Ready to Begin Your NPSC Journey?
//             </motion.h2>
//             <motion.p
//               className="text-lg text-gray-200 mb-8"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Join our comprehensive coaching programs and test series to
//               maximize your chances of success in the NPSC examination.
//             </motion.p>
//             <motion.div
//               className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <Link
//                 to="/courses"
//                 className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
//               >
//                 Explore Courses
//               </Link>
//               <Link
//                 to="/test-series"
//                 className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
//               >
//                 View Test Series
//               </Link>
//             </motion.div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default BlogDetailPage;
// pages/BlogDetailPage.jsx
import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "react-toastify";
import { CONSTANTS } from "../constants/Constants";
import Loader from "../components/common/Spinner";
import { useAuth } from "../context/AuthContext"; // Assuming you have an auth context

const BlogDetailPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth(); // Get current user if available
  
  const [blog, setBlog] = useState(null);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  
  // Comment form state
  const [commentForm, setCommentForm] = useState({
    author: currentUser?.name || "",
    email: currentUser?.email || "",
    text: ""
  });
  const [submittingComment, setSubmittingComment] = useState(false);
  
  // Social interaction state
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [shareCount, setShareCount] = useState(0);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    loadCategories();
    loadBlogPost();
  }, [slug]);
  
  // Update form if user changes
  useEffect(() => {
    if (currentUser) {
      setCommentForm(prev => ({
        ...prev,
        author: currentUser.name || prev.author,
        email: currentUser.email || prev.email
      }));
    }
  }, [currentUser]);
  
  const loadCategories = async () => {
    try {
      const response = await axios.get(`${CONSTANTS.APIURL}/api/blog-categories?active=true`);
      setCategories(response.data.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };
  
  const loadBlogPost = async () => {
    try {
      setLoading(true);
      
      const response = await axios.get(`${CONSTANTS.APIURL}/api/blog-posts/${slug}`);
      setBlog(response.data.data);
      setRelatedPosts(response.data.relatedPosts || []);
      
      // Set social counts
      if (response.data.data) {
        setLikeCount(response.data.data.likes || 0);
        setShareCount(response.data.data.shares || 0);
      }
      
      setLoading(false);
    } catch (error) {
      console.error('Error fetching blog post:', error);
      toast.error('Failed to load blog post');
      setLoading(false);
      navigate('/blog');
    }
  };
  
  const handleCommentChange = (e) => {
    const { name, value } = e.target;
    setCommentForm({
      ...commentForm,
      [name]: value
    });
  };
  
  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    
    if (!commentForm.author || !commentForm.email || !commentForm.text) {
      toast.error('Please fill all the required fields');
      return;
    }
    
    try {
      setSubmittingComment(true);
      
      await axios.post(`${CONSTANTS.APIURL}/api/blog-posts/${blog._id}/comments`, commentForm);
      
      toast.success('Your comment has been submitted successfully');
      
      // Reset form text field
      setCommentForm({
        ...commentForm,
        text: ""
      });
      
      // Reload post to get updated comments
      loadBlogPost();
    } catch (error) {
      console.error('Error submitting comment:', error);
      toast.error('Failed to submit comment. Please try again later.');
    } finally {
      setSubmittingComment(false);
    }
  };
  
  const handleLike = async () => {
    if (liked) return; // Prevent multiple likes
    
    try {
      const response = await axios.post(`${CONSTANTS.APIURL}/api/blog-posts/${blog._id}/like`);
      setLikeCount(response.data.data.likes);
      setLiked(true);
      
      // Store liked state in localStorage
      localStorage.setItem(`blog_liked_${blog._id}`, 'true');
    } catch (error) {
      console.error('Error liking post:', error);
    }
  };
  
  const handleShare = async (platform) => {
    let shareUrl = '';
    const postUrl = `${window.location.origin}/blog/${blog.slug}`;
    const postTitle = blog.title;
    
    // Create share URLs for different platforms
    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(postUrl)}&text=${encodeURIComponent(postTitle)}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(postUrl)}&title=${encodeURIComponent(postTitle)}`;
        break;
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(postTitle + ' ' + postUrl)}`;
        break;
      default:
        // Copy link to clipboard
        navigator.clipboard.writeText(postUrl);
        toast.success('Link copied to clipboard');
        break;
    }
    
    // Open share dialog if URL exists
    if (shareUrl) {
      window.open(shareUrl, '_blank', 'width=600,height=400');
    }
    
    // Update share count
    try {
      const response = await axios.post(`${CONSTANTS.APIURL}/api/blog-posts/${blog._id}/share`);
      setShareCount(response.data.data.shares);
    } catch (error) {
      console.error('Error updating share count:', error);
    }
  };
  
  // Function to render content sections
  const renderContent = (section, index) => {
    if (section.type === "paragraph") {
      return (
        <p key={index} className="mb-6 text-gray-700 leading-relaxed">
          {section.text}
        </p>
      );
    } else if (section.type === "heading") {
      return (
        <h2 key={index} className="text-2xl font-bold text-gray-900 mt-8 mb-4">
          {section.text}
        </h2>
      );
    } else if (section.type === "subheading") {
      return (
        <h3
          key={index}
          className="text-xl font-semibold text-gray-800 mt-6 mb-3"
        >
          {section.text}
        </h3>
      );
    } else if (section.type === "list") {
      return (
        <ul key={index} className="list-disc pl-6 mb-6 space-y-2">
          {section.items.map((item, itemIndex) => (
            <li key={itemIndex} className="text-gray-700">
              {item}
            </li>
          ))}
        </ul>
      );
    } else if (section.type === "blockquote") {
      return (
        <blockquote
          key={index}
          className="border-l-4 border-indigo-500 pl-4 italic my-6 text-gray-600"
        >
          {section.text}
        </blockquote>
      );
    } else if (section.type === "image") {
      return (
        <figure key={index} className="my-8">
          <img
            src={section.src}
            alt={section.alt || "Blog image"}
            className="w-full rounded-lg shadow-md"
          />
          {section.caption && (
            <figcaption className="text-center text-sm text-gray-500 mt-2">
              {section.caption}
            </figcaption>
          )}
        </figure>
      );
    } else if (section.type === "conclusion") {
      return (
        <div
          key={index}
          className="mt-8 p-4 bg-indigo-50 rounded-lg border border-indigo-100"
        >
          <h3 className="text-xl font-semibold text-indigo-800 mb-2">
            Conclusion
          </h3>
          <p className="text-gray-700">{section.text}</p>
        </div>
      );
    }
    return null;
  };
  
  // Format date helper function
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };
  
  // Get category name helper function
  const getCategoryName = (categoryId) => {
    const category = categories.find(cat => cat.identifier === categoryId);
    return category ? category.name : categoryId;
  };
  
  // Check if already liked
  useEffect(() => {
    if (blog) {
      const isLiked = localStorage.getItem(`blog_liked_${blog._id}`) === 'true';
      setLiked(isLiked);
    }
  }, [blog]);

  if (loading) {
    return (
      <div className="pt-20 flex justify-center items-center min-h-screen bg-gray-50">
        <div className="text-center">
          <Loader />
          <p className="mt-3 text-gray-600">Loading article...</p>
        </div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="pt-20 flex justify-center items-center min-h-screen bg-gray-50">
        <div className="text-center max-w-lg mx-auto px-4">
          <svg
            className="h-16 w-16 text-gray-400 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h2 className="mt-4 text-xl font-bold text-gray-700">
            Article Not Found
          </h2>
          <p className="mt-2 text-gray-500">
            The article you're looking for doesn't exist or has been removed.
          </p>
          <Link
            to="/blog"
            className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Back to Blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-20 bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gray-900 opacity-80"></div>
          <img
            src={blog.image}
            alt={blog.title}
            className="absolute inset-0 w-full h-full object-cover opacity-40"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800 mb-6"
            >
              {getCategoryName(blog.category)}
            </motion.div>

            <motion.h1
              className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              {blog.title}
            </motion.h1>

            <motion.div
              className="flex items-center justify-center space-x-4 text-sm"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <span className="flex items-center">
                <svg
                  className="h-4 w-4 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                {formatDate(blog.date)}
              </span>
              <span className="flex items-center">
                <svg
                  className="h-4 w-4 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                {blog.readTime}
              </span>
              <span className="flex items-center">
                <svg
                  className="h-4 w-4 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
                {blog.views.toLocaleString()} views
              </span>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Author Info */}
      <section className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="h-12 w-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 text-lg font-bold">
                {blog.author?.name?.charAt(0) || 'A'}
              </div>
            </div>
            <div className="ml-4">
              <div className="text-lg font-medium text-gray-900">
                {blog.author?.name || 'Author'}
              </div>
              <div className="text-sm text-gray-600">{blog.authorPosition || 'Content Writer'}</div>
            </div>
            <div className="ml-auto flex space-x-2">
              <button className="inline-flex items-center px-3 py-1 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 bg-white hover:bg-gray-50">
                <svg
                  className="h-4 w-4 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                  />
                </svg>
                Follow
              </button>
              <button className="inline-flex items-center px-3 py-1 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 bg-white hover:bg-gray-50">
                <svg
                  className="h-4 w-4 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                Contact
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section with Sidebar - Grid Layout for full width */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            {/* Main Content - Takes more width */}
            <div className="lg:col-span-8 xl:col-span-9">
              <motion.div
                className="bg-white rounded-lg shadow-md overflow-hidden"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <div className="p-6 md:p-8">
                  <div className="prose prose-indigo max-w-none">
                    {blog.content.map((section, index) =>
                      renderContent(section, index)
                    )}
                  </div>

                  {/* Tags */}
                  <div className="mt-8 pt-6 border-t border-gray-200">
                    <h4 className="text-sm font-medium text-gray-500 mb-3">
                      Tags
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {blog.tags.map((tag, index) => (
                        <Link
                          key={index}
                          to={`/blog/tag/${tag
                            .toLowerCase()
                            .replace(/\s+/g, "-")}`}
                          className="px-3 py-1 bg-gray-100 hover:bg-gray-200 text-sm text-gray-700 rounded-full"
                        >
                          {tag}
                        </Link>
                      ))}
                    </div>
                  </div>

                  {/* Social Sharing */}
                  <div className="mt-8 pt-6 border-t border-gray-200">
                    <div className="flex items-center justify-between">
                      <div className="flex space-x-4">
                        <button 
                          className={`flex items-center ${liked ? 'text-red-500 hover:text-red-600' : 'text-gray-600 hover:text-red-500'}`}
                          onClick={handleLike}
                          disabled={liked}
                        >
                          <svg
                            className="h-5 w-5 mr-1"
                            fill={liked ? "currentColor" : "none"}
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                            />
                          </svg>
                          <span>{likeCount} Likes</span>
                        </button>
                        <button className="flex items-center text-gray-600 hover:text-indigo-600">
                          <svg
                            className="h-5 w-5 mr-1"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                            />
                          </svg>
                          <span>{blog.comments?.length || 0} Comments</span>
                        </button>
                      </div>
                      <div className="flex space-x-2">
                        <button 
                          className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-full"
                          onClick={() => handleShare('twitter')}
                        >
                          <svg
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                          </svg>
                        </button>
                        <button 
                          className="p-2 text-gray-500 hover:text-blue-800 hover:bg-blue-50 rounded-full"
                          onClick={() => handleShare('linkedin')}
                        >
                          <svg
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                          </svg>
                        </button>
                        <button 
                          className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-full"
                          onClick={() => handleShare('facebook')}
                        >
                          <svg
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                          </svg>
                        </button>
                        <button 
                          className="p-2 text-gray-500 hover:text-green-600 hover:bg-green-50 rounded-full"
                          onClick={() => handleShare('whatsapp')}
                        >
                          <svg
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Comments Section */}
                  <div className="mt-8 pt-6 border-t border-gray-200">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">
                      Comments ({blog.comments?.length || 0})
                    </h3>

                    {/* Comment Form */}
                    <div className="mb-8">
                      <h4 className="text-lg font-medium text-gray-900 mb-4">
                        Leave a comment
                      </h4>
                      <form className="space-y-4" onSubmit={handleCommentSubmit}>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                          <div>
                            <label
                              htmlFor="author"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Name
                            </label>
                            <input
                              type="text"
                              id="author"
                              name="author"
                              value={commentForm.author}
                              onChange={handleCommentChange}
                              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              placeholder="Your name"
                              required
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="email"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Email
                            </label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              value={commentForm.email}
                              onChange={handleCommentChange}
                              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              placeholder="Your email (will not be published)"
                              required
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="text"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Comment
                          </label>
                          <textarea
                            id="text"
                            name="text"
                            value={commentForm.text}
                            onChange={handleCommentChange}
                            rows="4"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            placeholder="Share your thoughts..."
                            required
                          ></textarea>
                        </div>
                        <div>
                          <button
                            type="submit"
                            disabled={submittingComment}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-70"
                          >
                            {submittingComment ? 'Posting...' : 'Post Comment'}
                          </button>
                        </div>
                      </form>
                    </div>

                    {/* Comments List */}
                    {blog.comments && blog.comments.length > 0 ? (
                      <div className="space-y-6">
                        {blog.comments.map((comment) => (
                          <div
                            key={comment._id}
                            className="bg-gray-50 p-4 rounded-lg"
                          >
                            <div className="flex">
                              <div className="flex-shrink-0 mr-3">
                                <div className="h-10 w-10 rounded-full bg-indigo-200 flex items-center justify-center text-indigo-600 font-medium">
                                  {comment.author.charAt(0)}
                                </div>
                              </div>
                              <div className="flex-1">
                                <div className="flex items-center justify-between">
                                  <h5 className="text-sm font-medium text-gray-900">
                                    {comment.author}
                                  </h5>
                                  <span className="text-xs text-gray-500">
                                    {formatDate(comment.date)}
                                  </span>
                                </div>
                                <div className="mt-2 text-sm text-gray-700">
                                  <p>{comment.text}</p>
                                </div>
                                <div className="mt-2 flex items-center space-x-4">
                                  <button className="text-xs text-gray-500 hover:text-indigo-600 flex items-center">
                                    <svg
                                      className="h-4 w-4 mr-1"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                                      />
                                    </svg>
                                    Like
                                  </button>
                                  <button className="text-xs text-gray-500 hover:text-indigo-600 flex items-center">
                                    <svg
                                      className="h-4 w-4 mr-1"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                                      />
                                    </svg>
                                    Reply
                                  </button>
                                </div>

                                {/* Comment Replies */}
                                {comment.replies &&
                                  comment.replies.length > 0 && (
                                    <div className="mt-4 pl-5 border-l-2 border-gray-200 space-y-4">
                                      {comment.replies.map((reply) => (
                                        <div
                                          key={reply._id}
                                          className="bg-white p-3 rounded"
                                        >
                                          <div className="flex">
                                            <div className="flex-shrink-0 mr-3">
                                              <div className="h-8 w-8 rounded-full bg-indigo-200 flex items-center justify-center text-indigo-600 font-medium text-xs">
                                                {reply.author.charAt(0)}
                                              </div>
                                            </div>
                                            <div className="flex-1">
                                              <div className="flex items-center justify-between">
                                                <h6 className="text-sm font-medium text-gray-900">
                                                  {reply.author}
                                                </h6>
                                                <span className="text-xs text-gray-500">
                                                  {formatDate(reply.date)}
                                                </span>
                                              </div>
                                              <div className="mt-1 text-sm text-gray-700">
                                                <p>{reply.text}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-8 bg-gray-50 rounded-lg">
                        <svg className="h-12 w-12 text-gray-400 mx-auto mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                        </svg>
                        <p className="text-gray-600">Be the first to comment on this article!</p>
                      </div>
                    )}
                  </div>
                </div>
              </motion.div>
            </div>

            {/* Sidebar - Takes less width */}
            <div className="lg:col-span-4 xl:col-span-3">
              <div className="space-y-6">
                {/* Author Card */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">
                    About the Author
                  </h3>
                  <div className="flex flex-col items-center text-center">
                    <div className="h-24 w-24 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 text-3xl font-bold mb-4">
                      {blog.author?.name?.charAt(0) || 'A'}
                    </div>
                    <h4 className="text-lg font-medium text-gray-900">
                      {blog.author?.name || 'Author'}
                    </h4>
                    <p className="text-sm text-gray-600 mb-4">
                      {blog.authorPosition || 'Content Writer'}
                    </p>
                    <p className="text-sm text-gray-600 mb-4">
                      Expert in NPSC examination patterns and Nagaland
                      administrative affairs. Former civil servant with over 15
                      years of experience.
                    </p>
                    <button className="w-full inline-flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                      View Full Profile
                    </button>
                  </div>
                </div>

                {/* Related Posts */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">
                    Related Articles
                  </h3>
                  <div className="space-y-4">
                    {relatedPosts.map((post) => (
                      <Link
                        key={post._id}
                        to={`/blog/${post.slug}`}
                        className="block group"
                      >
                        <div className="flex">
                          <div className="flex-shrink-0 h-14 w-14 rounded overflow-hidden">
                            <img
                              src={post.image}
                              alt={post.title}
                              className="h-full w-full object-cover group-hover:opacity-80 transition-opacity"
                            />
                          </div>
                          <div className="ml-3">
                            <p className="text-sm font-medium text-gray-900 group-hover:text-indigo-600 transition-colors line-clamp-2">
                              {post.title}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                              {formatDate(post.date)}
                            </p>
                          </div>
                        </div>
                      </Link>
                    ))}
                    
                    {relatedPosts.length === 0 && (
                      <p className="text-sm text-gray-500 italic">No related articles found</p>
                    )}
                    
                    <Link
                      to="/blog"
                      className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-800 mt-2"
                    >
                      View All Articles
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 ml-1"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>

                {/* Categories */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">
                    Categories
                  </h3>
                  <div className="space-y-2">
                    {categories.map((category) => (
                      <Link
                        key={category._id}
                        to={`/blog/category/${category.identifier}`}
                        className="flex items-center justify-between py-2 px-3 rounded-md hover:bg-gray-50"
                      >
                        <span className="text-sm text-gray-700">
                          {category.name}
                        </span>
                        {category.postsCount !== undefined && (
                          <span className="text-xs bg-gray-100 px-2 py-1 rounded-full text-gray-600">
                            {category.postsCount}
                          </span>
                        )}
                      </Link>
                    ))}
                  </div>
                </div>

                {/* Newsletter */}
                <div className="bg-gradient-to-r from-indigo-600 to-blue-700 rounded-lg shadow-md p-6 text-white">
                  <h3 className="text-lg font-medium mb-4">
                    Subscribe to Newsletter
                  </h3>
                  <p className="text-sm text-indigo-100 mb-4">
                    Get the latest NPSC updates and preparation tips delivered
                    to your inbox.
                  </p>
                  <form className="space-y-3">
                    <div>
                      <input
                        type="email"
                        placeholder="Your email address"
                        className="block w-full px-4 py-2 rounded-md border-0 text-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-300 focus:ring-offset-indigo-600"
                      />
                    </div>
                    <button
                      type="submit"
                      className="w-full bg-white text-indigo-600 px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors"
                    >
                      Subscribe
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Next/Previous Article Navigation - Full Width */}
      <section className="bg-gray-100 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Link
              to="/blog"
              className="group block bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-1">
                  <svg
                    className="h-4 w-4 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                  Back to Blog
                </div>
                <h3 className="text-lg font-medium text-gray-900 group-hover:text-indigo-600 transition-colors">
                  View all articles
                </h3>
              </div>
            </Link>

            {relatedPosts.length > 0 && (
              <Link
                to={`/blog/${relatedPosts[0].slug}`}
                className="group block bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-6 text-right">
                  <div className="flex items-center justify-end text-sm text-gray-500 mb-1">
                    Related Article
                    <svg
                      className="h-4 w-4 ml-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 group-hover:text-indigo-600 transition-colors">
                    {relatedPosts[0].title}
                  </h3>
                </div>
              </Link>
            )}
          </div>
        </div>
      </section>

      {/* More Articles You May Like - Full Width Grid */}
      {relatedPosts.length > 0 && (
        <section className="py-12 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">
              More Articles You May Like
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {relatedPosts.map((post) => (
                <motion.div
                  key={post._id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border border-gray-100"
                >
                  <Link to={`/blog/${post.slug}`}>
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-48 object-cover"
                    />
                  </Link>
                  <div className="p-5">
                    <Link
                      to={`/blog/${post.slug}`}
                      className="block mt-2 text-xl font-semibold text-gray-900 hover:text-indigo-600 transition-colors duration-200 mb-2"
                    >
                      {post.title}
                    </Link>
                    <p className="text-gray-600 line-clamp-3 mb-4">
                      {post.excerpt}
                    </p>

                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div className="flex-shrink-0">
                          <div className="h-8 w-8 rounded-full bg-indigo-200 flex items-center justify-center text-indigo-600 font-medium">
                            {post.author?.name?.charAt(0) || 'A'}
                          </div>
                        </div>
                        <div className="ml-2">
                          <p className="text-sm font-medium text-gray-900">
                            {post.author?.name || 'Author'}
                          </p>
                          <p className="text-xs text-gray-500">{formatDate(post.date)}</p>
                        </div>
                      </div>

                      <Link
                        to={`/blog/${post.slug}`}
                        className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-800"
                      >
                        Read more
                      </Link>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-indigo-900 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <motion.h2
              className="text-3xl font-extrabold mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Ready to Begin Your NPSC Journey?
            </motion.h2>
            <motion.p
              className="text-lg text-gray-200 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Join our comprehensive coaching programs and test series to
              maximize your chances of success in the NPSC examination.
            </motion.p>
            <motion.div
              className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Link
                to="/courses"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
              >
                Explore Courses
              </Link>
              <Link
                to="/test-series"
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
              >
                View Test Series
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogDetailPage;